import React, { useEffect } from 'react'
import Container from '../../../Container/Container'
import { useForm } from "react-hook-form";
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
function AddDescriptions({ onSubmit, onBack, ticket, initialValues, isSubmitting }) {
    const location = useLocation()
    const profile = useSelector((state) => state.profile.profile);
    const { register, handleSubmit, formState: { errors }, getValues, setValue } = useForm({
        defaultValues: initialValues
    });

    useEffect(() => {
        if (!getValues("SubmittedBy")) {
            setValue("SubmittedBy", `${profile?.firstName || ""} ${profile?.lastName || ""}`);
        }
    }, [profile, setValue, getValues]);

    const handleBack = () => {
        const currentValues = getValues();
        onBack(currentValues);
    };

    return (
        <Container>
            <div class="nk-content">
                <div class="container-fluid">
                    <div class="nk-content-inner">
                        <div class="nk-content-body">
                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between">
                                    <div class="nk-block-head-content">
                                        <h3 class="nk-block-title page-title">{location.pathname == "/add-wedding-order" ? "Add" : "Update"} Weddings Event {(ticket && location.pathname != "/add-wedding-order") && `#${ticket}`}</h3></div>
                                </div>
                            </div>

                            <div class="card card-full">
                                <div class="card-inner">
                                    <div class="stepperLeft">
                                        <div className="row">
                                            <div className="col-md-4 brIght">
                                                <section className="section1">
                                                    <header>
                                                        <div className="bead complete"><span><i class="fa-solid fa-check"></i></span></div> {location.pathname == "/add-wedding-order" ? "Add" : "Update"}  Groom's Detail
                                                    </header>
                                                </section>
                                                <section className="section2">
                                                    <header>
                                                        <div className="bead complete"><span><i class="fa-solid fa-check"></i></span></div>{location.pathname == "/add-wedding-order" ? "Add" : "Update"}  Bride's Detail
                                                    </header>
                                                </section>
                                                {
                                                    location.pathname == "/add-wedding-order" &&
                                                    <section className="section2">
                                                        <header>
                                                            <div className="bead complete"><span><i class="fa-solid fa-check"></i></span></div> {location.pathname == "/add-wedding-order" ? "Add" : "Update"} Groom's Style Detail
                                                        </header>
                                                    </section>
                                                }

                                                {
                                                    location.pathname == "/add-wedding-order" &&
                                                    <section className="section2">
                                                        <header>
                                                            <div className="bead complete"><span><i class="fa-solid fa-check"></i></span></div> {location.pathname == "/add-wedding-order" ? "Add" : "Update"} Groomsmen Style Detail
                                                        </header>
                                                    </section>

                                                }

                                                <section>
                                                    <header>
                                                        <div className="bead current"><span>{location.pathname == "/update-wedding-order" ? 3 : 5}</span></div> {location.pathname == "/add-wedding-order" ? "Add" : "Update"} Notes
                                                    </header>
                                                </section>
                                            </div>

                                            <div className="col-md-8">
                                                <h4>{location.pathname == "/add-wedding-order" ? "Add" : "Update"} Notes </h4>
                                                <div className="inputCardBox mt-4">
                                                    {/* <form onSubmit={handleSubmit(onSubmit)}> */}
                                                    <form onSubmit={handleSubmit(onSubmit)}>

                                                        <div className="row">
                                                            <div className="col-md-12 mb-3">
                                                                <label>Notes  <span className="text-red-500"></span></label>
                                                                <textarea className="" placeholder='For Your Reference Only'  {...register("Notes")}></textarea>
                                                                {errors.Notes && <p className='red'>{errors.Notes.message}</p>}

                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label>Submitted By  <span className="text-red-500">*</span></label>
                                                                <input class="" type="text" placeholder="Enter name"  {...register("SubmittedBy", { required: "Submitted by is required" })} />
                                                                {errors.SubmittedBy && <p className='red'>{errors.SubmittedBy.message}</p>}
                                                            </div>

                                                            <div class="col-md-12 mt-3">
                                                                <a className="backBtnWedding" style={{ cursor: "pointer" }} onClick={handleBack}>Back</a>
                                                                <button type="submit" style={isSubmitting ? { pointerEvents: "none" } : {}}
                                                                    class="addBtnCustomer">
                                                                    {isSubmitting ? (
                                                                        <>
                                                                            <span class="spinner"></span> Submit
                                                                        </>
                                                                    ) : (
                                                                        "Submit"
                                                                    )}
                                                                </button>                                                          </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Container>
    )
}

export default AddDescriptions
